import { useContext } from 'react';

import { XYChartTooltipContext } from '../context/XYChartTooltip.context.js';

export const useXYChartTooltip = () => useContext(XYChartTooltipContext);
